import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
// import Cropper from "cropper js"
import axios from "axios"
// 引入封装getpost请求
import {FucGet,FucPost} from './request/http.js'
Vue.prototype.$FucPost= FucPost;
Vue.prototype.$FucGet= FucGet;
// 序列化qs方法
import Qs from 'qs'
Vue.prototype.$Qs = Qs
// 公用api方法
import api from './request/api.js'
Vue.use(api)

import Header from '@/views/Header.vue'
Vue.component('Header',Header)
import Footer from '@/views/Footer.vue'
Vue.component('Footer',Footer)
import LoginPop from '@/components/loginPop'
Vue.component('LoginPop',LoginPop)
import MyPopup from '@/components/myPopup'
Vue.component('MyPopup',MyPopup)
import mainLeft from '@/components/mainLeft'
Vue.component('MainLeft',mainLeft)
import VueI18n from "vue-i18n"    //语言包

 Vue.use(VueI18n)
 const i18n = new VueI18n({
     // locale: uni.getStorageSync('lang') == (undefined || "" || null) ?
     //     "zh" :
     //     uni.getStorageSync('lang'),
     locale: localStorage.getItem("lang") == (undefined || "" || null) ? localStorage.setItem("lang","en"):localStorage.getItem("lang"),
     messages: {
         en: require("./lang/en.json"),
         zh: require("./lang/zh.json"),
         es: require("./lang/es.json"),
         pt: require("./lang/pt.json")
     },
    // silentTranslationWarn: true,
 });
 Vue.prototype._i18n = i18n
 
 import ElementUI from 'element-ui'
 import 'element-ui/lib/theme-chalk/index.css'
 Vue.use(ElementUI)
 
//每次跳转时回到顶部
 router.beforeEach((to, from, next) => {    
  // chrome
  document.body.scrollTop = 0
  // firefox
  document.documentElement.scrollTop = 0
  // safari
  window.pageYOffset = 0
  next()
})

//rem自适应
import './utils/rem.js'

Vue.config.productionTip = false

let vm=new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
export default vm
